import { IQuery, IQueryMediator } from 'core-ts-types';
import { IInTakeSurveyQuestionMeta } from '../builders/ap_intake_survey_builder';
import { IInTakeSurveyAnswersDatasource } from '../datasources/intake_survey_answers_datasource';
import { IInTakeSurveyQuestionChoicesDatasource } from '../datasources/intake_survey_choices_datasource';
import { IInTakeSurveyQuestionDatasource } from '../datasources/intake_survey_questions_datasource';
import { ApIntakeSurveyAnswerStrategy } from '../strategies/ap_intake_survey_answer_strategy';
import { QuestionTypeInputTypeStrategy } from '../strategies/question_type_input_type_strategy';
import { APIntakeSurveyNKHelper } from './../../preview_plan/helpers/intake_survey_nk_helper';

import * as _4 from 'lodash4';
import { IInTakeSurveyQuestionChoice } from '../builders/ap_intake_survey_question_choice_builder';

interface IIntakeSurveyQuestionsQueryResult {
  questions: IInTakeSurveyQuestionMeta[];
}
export class GetIntakeSurveyQuestionsQuery implements IQuery {
  private __result: IIntakeSurveyQuestionsQueryResult;

  constructor(
    QueryMediator: IQueryMediator,
    private ngIntakeSurveyQuestionsDatasource: IInTakeSurveyQuestionDatasource,
    private ngIntakeSurveyChoicesDatasource: IInTakeSurveyQuestionChoicesDatasource,
    private ngIntakeSurveyAnswersDatasource: IInTakeSurveyAnswersDatasource,
    private ngAPIntakeSurveyNKHelper: APIntakeSurveyNKHelper
  ) {
    QueryMediator.registerQuery(
      this,
      ngIntakeSurveyQuestionsDatasource,
      ngIntakeSurveyChoicesDatasource,
      ngIntakeSurveyAnswersDatasource
    );
  }
  run(): this {
    const questions = [...this.ngIntakeSurveyQuestionsDatasource.values()];
    const choices = this.ngIntakeSurveyChoicesDatasource.read();
    const answers = this.ngIntakeSurveyAnswersDatasource.read();
    const _questions = questions.map((question: IInTakeSurveyQuestionMeta) => {
      question._question_type = QuestionTypeInputTypeStrategy[question.question_type];
      question._answer = ApIntakeSurveyAnswerStrategy[_4.get(question, '_question_type', '')](
        question,
        choices,
        answers
      );
      question._choices = _4.filter(choices, (choice: IInTakeSurveyQuestionChoice) =>
        _4.includes(question.active_choices, choice.id)
      );
      return question;
    });
    const validQuestionNks = [
      this.ngAPIntakeSurveyNKHelper.intakeSurveyTermPreferenceNK,
      this.ngAPIntakeSurveyNKHelper.intakeSurveyTimeCommitmentNK
    ];
    this.__result = {
      questions: _questions.filter((qstn) => _4.includes(validQuestionNks, qstn.nk))
    };

    return this;
  }
  get result() {
    return this.__result;
  }
}

angular
  .module('capability-ng-academic-planner')
  .service('ngGetIntakeSurveyQuestionsQuery', GetIntakeSurveyQuestionsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/queries/get_intake_survey_questions_query.ts